import React from 'react';
import { SvgIcon } from '@mui/material';

export const Marker = ({ bgColor = 'none', width = 29, height = 48 }) => {
  return (
    <SvgIcon viewBox="0 0 29 48" style={{ width: `${width}px`, height: `${height}px` }}>
      <path
        d="M13.99 13.8c-.19-.08-.36-.19-.49-.33L10.92 10.48C10.33 9.84 11 8 12.12 8h5.16c1.11 0 1.81 1.35 1.22 2L15.9 13.47c-.13.14-.3.25-.49.33v21.71c0 .27-.32.48-.7.48s-.7-.21-.7-.48V13.8z"
        fill={bgColor}
      />
    </SvgIcon>
  );
};
